export class ThemeHolder {
    static activeTheme = null;
}